function loadCustomEvent(event, detail) {
  window.dispatchEvent(new CustomEvent(event), { detail });
}

export default loadCustomEvent;
